export const Gender = Object.freeze({
  Male: 'Male',
  Female: 'Female',
  NonBinary: 'NonBinary',
  PreferNotToSay: 'PreferNotToSay',
});
